import Spinner from "@/components/Spinner";
import SuspenseOutlet from "@/components/SuspenseOutlet";
import { useAuth } from "@/contexts/AuthHook";
import { Navigate, useLocation } from "react-router-dom";

/**
 * AttorneyLayout - A layout component for attorney routes
 * Provides authentication protection
 */
const AttorneyLayout: React.FC = () => {
  const { session, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Spinner />;
  }

  if (!session || !user) {
    return (
      <Navigate
        to="/auth/sign-in-with-magic-link"
        replace
        state={{ from: location }}
      />
    );
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <main className="flex h-full max-w-full flex-1 flex-col overflow-hidden">
        <SuspenseOutlet />
      </main>
    </div>
  );
};

export default AttorneyLayout;
